import { faBan, faExternalLinkAlt, faGift, faPlay, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@themesberg/react-bootstrap';
import moment from 'moment';
import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Routes } from '../../../../routes';
import { useCookies } from 'react-cookie';
import { refundCartGroup, updateCartGroup, distributeReward, removeCartGroup } from '../../../../controller/api/cartGroup';

export const TableRow = (props) => {
  const { gameId, expiredAt, createdAt, estimatedValue, actualValue, isCreatedByAdmin, status, id, completedAt, activatedAt, canceledAt, onRefresh, hasTicket, rewardAmount, isDistributedReward, pageStatus } = props;
  const [cookies] = useCookies(['lottmekong']);
  const [activating, setActivating] = useState(false);
  const [canceling, setCanceling] = useState(false);
  const [distributing, setDistributing] = useState(false);
  const [removing, setRemoving] = useState(false);

  const ticketLink = Routes.VietlottTicketDetail.path.replace(':id', id)
  const detailLink = Routes.VietlottGroupDetail.path.replace(':id', id)

  const createdAtString = moment(createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()

  const completedAtString = completedAt ? moment(completedAt).format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  const activatedAtString = activatedAt ? moment(activatedAt).format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  const canceledAtString = canceledAt ? moment(canceledAt).format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  const expiredAtString = expiredAt ? moment(expiredAt).format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  let statusText = ''
  let statusColor = ''

  if (status === 0) {
    statusText = 'Không hoạt động'
    statusColor = 'warning'
  } else if (status === 1) {
    const percent = Math.round((actualValue / estimatedValue) * 100)
    statusText = `${percent}%`
    statusColor = 'primary'
  } else if (status === 2) {
    statusText = 'Đã hoàn thành'
    statusColor = 'success'
  } else if (status === 3) {
    statusText = 'Đã bị hủy'
    statusColor = 'danger'
  } else if (status === 4) {
    statusText = 'Trúng thưởng'
    statusColor = 'info'
  } else if (status === 5) {
    statusText = 'Không trúng thưởng'
    statusColor = 'secondary'
  } else if (status === 6) {
    statusText = 'Đã bị xóa'
    statusColor = 'dark'
  }

  const handleActivate = async () => {
    if (activating) return;
    setActivating(true);
    try {
      const response = await updateCartGroup(cookies.lottmekong, id, 1);
      if (response && response.error === 0) {
        if (onRefresh) onRefresh();
      } else {
        alert(response?.message || 'Có lỗi xảy ra');
      }
    } catch (err) {
      alert('Có lỗi xảy ra');
    } finally {
      setActivating(false);
    }
  };

  const handleCancel = async () => {
    if (canceling) return;
    
    // Check if there are transactions (contributions) in this cart group
    let confirmMessage = 'Bạn có chắc chắn muốn hủy nhóm này?';
    if (actualValue > 0) {
      const formattedValue = new Intl.NumberFormat('vi-VN').format(actualValue);
      confirmMessage = `⚠️ CẢNH BÁO: Nhóm này đã có giao dịch!\n\nTổng số tiền đã góp: ${formattedValue}đ\n\nNếu hủy, các thành viên sẽ được hoàn tiền.\n\nBạn có chắc chắn muốn hủy nhóm này?`;
    }
    
    if (!window.confirm(confirmMessage)) return;
    setCanceling(true);
    try {
      const response = await refundCartGroup(cookies.lottmekong, id);
      if (response && response.error === 0) {
        if (onRefresh) onRefresh();
      } else {
        alert(response?.message || 'Có lỗi xảy ra');
      }
    } catch (err) {
      alert('Có lỗi xảy ra');
    } finally {
      setCanceling(false);
    }
  };

  const handleDistributeReward = async () => {
    if (distributing) return;
    
    const formattedReward = new Intl.NumberFormat('vi-VN').format(rewardAmount);
    if (!window.confirm(`Bạn có chắc chắn muốn phân phối giải thưởng ${formattedReward}đ cho các thành viên?`)) return;
    
    setDistributing(true);
    try {
      const response = await distributeReward(cookies.lottmekong, id);
      if (response && response.error === 0) {
        alert('Phân phối giải thưởng thành công');
        if (onRefresh) onRefresh();
      } else {
        alert(response?.message || 'Có lỗi xảy ra');
      }
    } catch (err) {
      alert('Có lỗi xảy ra');
    } finally {
      setDistributing(false);
    }
  };

  const handleRemove = async () => {
    if (removing) return;
    if (!window.confirm('Bạn có chắc chắn muốn xóa nhóm này? Hành động không thể hoàn tác.')) return;
    setRemoving(true);
    try {
      const response = await removeCartGroup(cookies.lottmekong, id);
      if (response && response.error === 0) {
        if (onRefresh) onRefresh();
      } else {
        alert(response?.message || 'Có lỗi xảy ra');
      }
    } catch (err) {
      alert('Có lỗi xảy ra');
    } finally {
      setRemoving(false);
    }
  };

  // Check if this cart group has reward and hasn't been distributed yet
  const canDistributeReward = rewardAmount > 0 && isDistributedReward === 0;

  console.log('canDistributeReward', canDistributeReward, rewardAmount, isDistributedReward)

  const renderActionButton = () => {
    // If can distribute reward, show distribute button
    if (canDistributeReward) {
      return (
        <Button variant="warning" size="sm" onClick={handleDistributeReward} disabled={distributing}>
          <FontAwesomeIcon icon={faGift} className="me-1" />
          {distributing ? 'Đang xử lý...' : 'Phân phối'}
        </Button>
      );
    }

    switch (status) {
      case 0: // Không hoạt động - show Kích hoạt + Xóa buttons
        return (
          <div className="d-flex gap-1 justify-content-center">
            <Button variant="success" size="sm" onClick={handleActivate} disabled={activating || removing}>
              <FontAwesomeIcon icon={faPlay} className="me-1" />
              {activating ? '...' : 'Kích hoạt'}
            </Button>
            <Button variant="danger" size="sm" onClick={handleRemove} disabled={removing || activating}>
              <FontAwesomeIcon icon={faTrash} className="me-1" />
              {removing ? '...' : 'Xóa'}
            </Button>
          </div>
        )
      case 1: // Đang hoạt động
        return (
          <Button variant="danger" size="sm" onClick={handleCancel} disabled={canceling}>
            <FontAwesomeIcon icon={faBan} className="me-1" />
            {canceling ? 'Đang xử lý...' : 'Hủy'}
          </Button>
        )
      case 2: // Đã hoàn thành
        if (!hasTicket) return null
        return (
          <Button variant="success" size="sm">
            <Link
              target={'_blank'}
              style={{ color: '#fff', textDecoration: 'none' }}
              to={ticketLink}
            >
              Xem vé
              <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
            </Link>
          </Button>
        )
      case 3: // Đã bị hủy - no action
        return null
      case 4: // Trúng thưởng
        return (
          <Button variant="primary" size="sm">
            <Link
              target={'_blank'}
              style={{ color: '#fff', textDecoration: 'none' }}
              to={ticketLink}
            >
              Xem vé
              <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
            </Link>
          </Button>
        )
      case 5: // Không trúng thưởng
        if (!hasTicket) return null
        return (
          <Button variant="secondary" size="sm">
            <Link
              target={'_blank'}
              style={{ color: '#fff', textDecoration: 'none' }}
              to={ticketLink}
            >
              Xem vé
              <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
            </Link>
          </Button>
        )
      case 6: // Đã bị xóa - no action
        return null
      default:
        return (
          <Button variant="secondary" size="sm" disabled>
            N/A
          </Button>
        )
    }
  }

  return (
    <tr>
      <td className="text-center">
        {renderActionButton()}
      </td>
      <td className="text-center">
        <Link
          target={'_blank'}
          to={detailLink}
          style={{ color: '#0066cc', textDecoration: 'underline', cursor: 'pointer' }}
          onMouseEnter={(e) => e.target.style.color = '#0052a3'}
          onMouseLeave={(e) => e.target.style.color = '#0066cc'}
        >
          {id}
        </Link>
      </td>
      <td className='text-center'>
        <img alt='' src={require(`../../../../assets/img/logo-${gameId}.png`)} className="img-thumbnail" width={90} height={30}></img>
      </td>
      <td className='text-center'>
        {status === 0 && !expiredAtString ? (
          <span className="text-muted">Chưa xác định</span>
        ) : (
          expiredAtString || 'N/A'
        )}
      </td>
      <td className="text-center">{isCreatedByAdmin ? 'Admin' : 'Người dùng'}</td>
      <td className="text-center">{new Intl.NumberFormat('vn-VI', {}).format(estimatedValue) || ""}</td>
      {(pageStatus === 4 || pageStatus === 'completed') && (
        <td className="text-center text-success fw-bold">
          {new Intl.NumberFormat('vi-VN').format(rewardAmount || 0)}
        </td>
      )}
      <td className={`text-center bg-${statusColor}`}><b style={{ color: '#fff', fontSize: '17px' }}>{statusText}</b></td>
      <td>
        <b>Tạo lúc:</b> {createdAtString}<br />
        <b>Kích hoạt lúc:</b> {activatedAtString}<br />
        <b>Hoàn thành lúc:</b> {completedAtString}<br />
        <b>Hủy lúc:</b> {canceledAtString}
      </td>
    </tr>
  );
};